import { selfCheckInRoute } from 'src/apis';

export const memberships = `${selfCheckInRoute}/loyaltyPrograms/memberships`;
